module.exports = __webpack_public_path__ + "img/box-tick.386a5435.svg";